// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NXvcG","title":"styles_title__OatPF","deviceInfo":"styles_deviceInfo__sFh1j","card":"styles_card__sJaqF"};